import type { ClickableItem, VisibleItem } from 'layouts/main/sp-header/navigation/models';
import { NavigationItem } from 'layouts/main/sp-header/navigation/NavigationItem';
import { connect } from 'react-redux';
import { isDiscoverPageVisible } from 'state/selectors/common/router';
import type { AppState } from 'state/state.model';

function DiscoverItem({ isVisible, onClick }: VisibleItem & ClickableItem) {
  return (
    <NavigationItem
      targetRoute="/home"
      label="appHeader.laptop.menu.discover"
      dataE2eSuffix="welcome-page"
      category="Workspace"
      action="Discover"
      isVisible={isVisible}
      isDropdownItem={false}
      onClick={onClick}
    />
  );
}
export const ConnectedDiscoverItem = connect((state: AppState) => ({
  isVisible: isDiscoverPageVisible(state),
}))(DiscoverItem);
